import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Shared sx for sub-tab containers across the loyalty area. Matches the
 * top-level Société tabs (underlined indicator, semibold labels, primary
 * accent on the active tab).
 */
export const loyaltySubTabsContainerSx: SxProps<Theme> = (theme) => ({
  borderBottom: 1,
  borderColor: 'divider',
  mb: 3,
  '& .MuiTab-root': {
    minHeight: 44,
    fontWeight: 600,
    textTransform: 'none',
    color: 'text.secondary',
    transition: 'color 0.2s ease',
    '&:hover': { color: 'text.primary' },
  },
  '& .MuiTab-root.Mui-selected': {
    color: theme.palette.primary.main,
  },
  '& .MuiTabs-indicator': {
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
});
